import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDuW6ZhhDInKEl-NUnYPrWOv_SKNUggyiA",
  authDomain: "product-merche-77b93.firebaseapp.com",
  projectId: "product-merche-77b93",
  storageBucket: "product-merche-77b93.appspot.com",
  messagingSenderId: "986458266294",
  appId: "1:986458266294:web:f135ae7bcecb3ccc526417",
  measurementId: "G-J11NJ7RV3S"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = getStorage()

export {firebase, auth, firestore, storage}
